import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const DateFilterModal = ({ dateRangeFilter, setDateRangeFilter, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="modal-overlay" onClick={onClose} />
      <div className="modal-container">
        <button
          type="button"
          className="btn position-absolute top-0 start-0 m-1 fs-4"
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="text-center mb-3 fs-5 fw-bold">
          {t("Filter by date")}
        </div>

        {/* Ligne Date de début */}
        <div className="modal-row d-flex align-items-center mb-2">
          <label
            className="modal-label me-2 mb-0"
            style={{ whiteSpace: "nowrap" }}
          >
            {t("Start date")} : 
          </label>
          <DatePicker
            selected={dateRangeFilter.fromDate}
            onChange={(date) =>
              setDateRangeFilter({ ...dateRangeFilter, fromDate: date })
            }
            dateFormat="yyyy-MM-dd"
            className="form-control form-filter-date flex-grow-1"
          />
        </div>

        {/* Ligne Date de fin */}
        <div className="modal-row d-flex align-items-center">
          <label
            className="modal-label me-2 mb-0"
            style={{ whiteSpace: "nowrap", minWidth: "100px" }}
          >
            {t("End date")} :
          </label>
          <DatePicker
            selected={dateRangeFilter.toDate}
            onChange={(date) =>
              setDateRangeFilter({ ...dateRangeFilter, toDate: date })
            }
            dateFormat="yyyy-MM-dd"
            className="form-control form-filter-date flex-grow-1"
          />
        </div>

        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-danger px-4 rounded"
            onClick={() =>
              setDateRangeFilter({
                fromDate: null,
                toDate: null,
                filterType: "between",
              })
            }
          >
            {t("Reset")}
          </button>
        </div>
      </div>
    </>
  );
};

export default DateFilterModal;
